import { SvgIcon, SvgIconProps } from '@material-ui/core'

export default function CopyIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 24 24" fill="none" {...props}>
            <g transform="translate(2, 2)">
                <path
                    d="M2.70801 7.50016C2.70801 4.8538 4.85331 2.7085 7.49967 2.7085H13.3437C13.6889 2.7085 13.9687 2.98832 13.9687 3.3335C13.9687 3.67867 13.6889 3.9585 13.3437 3.9585H7.49967C5.54367 3.9585 3.95801 5.54415 3.95801 7.50016V13.4226C3.95801 13.7677 3.67819 14.0476 3.33301 14.0476C2.98783 14.0476 2.70801 13.7677 2.70801 13.4226V7.50016Z"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    fill="currentColor"
                />
                <path
                    d="M15.3351 5.66121C12.6343 5.35936 9.86503 5.35936 7.16424 5.66121C6.39484 5.7472 5.77656 6.3527 5.68588 7.12806C5.36556 9.86679 5.36556 12.6335 5.68588 15.3723C5.77656 16.1476 6.39484 16.7531 7.16424 16.8391C9.86503 17.141 12.6343 17.141 15.3351 16.8391C16.1045 16.7531 16.7228 16.1476 16.8135 15.3723C17.1338 12.6335 17.1338 9.86679 16.8135 7.12806C16.7228 6.3527 16.1045 5.7472 15.3351 5.66121Z"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    fill="currentColor"
                    d="M15.3351 5.66121C12.6343 5.35936 9.86503 5.35936 7.16424 5.66121C6.39484 5.7472 5.77656 6.3527 5.68588 7.12806C5.36556 9.86679 5.36556 12.6335 5.68588 15.3723C5.77656 16.1476 6.39484 16.7531 7.16424 16.8391C9.86503 17.141 12.6343 17.141 15.3351 16.8391C16.1045 16.7531 16.7228 16.1476 16.8135 15.3723C17.1338 12.6335 17.1338 9.86679 16.8135 7.12806C16.7228 6.3527 16.1045 5.7472 15.3351 5.66121Z"
                />
            </g>
        </SvgIcon>
    )
}
